import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
   Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Dialog,
    FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  DialogActions, DialogContent,  DialogContentText, DialogTitle, CardContent,
  Autocomplete
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useStyles } from "../../../theme/appStyles";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import {
  // useGetCategoryQuery,
  // useGetPrinterQuery,
  // useGetProductBrandQuery,
  // useGetProductQuery,
  // useGetVariantQuery,
  // useGetProductTagQuery,
  // useDeleteVariantMutation,
  // useGetModifierGroupQuery,
  // useGetModifierQuery,
  // useGetProductCategoryQuery,
  // useGetAllMainCategoryQuery,
  // useGetSubCategoryByArrayQuery,
  useGetVendorQuery,
  useGetInventoryQuery,
  useGetBillQuery
} from "../../../Api/attoDeskApi";
import {
  ICategory,
  IPrinter,
  IProduct,
  IProductBrand,
  IProductTag,
  IProductPopUP,
  IVariantPopUP,
  IModifierGroupPopUp,
  IModifierPopUp,
  ModifierInfo,
  IVendor,
  IProductInventory,
  IQuoteWorkOrder
} from "../../../Api/Interface/api.interface";
import { SizeOfLevelType } from "../../../Core/Enum/enum";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import Barcode from "react-barcode";
import placeholderImage from '../../../Images/fav.png';
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
// import EditVariantPopUp from "../Components/EditVariantPopUp";
// import CreateVariantPopUp from "../Components/CreateVariantPopUp";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import { useNotifier } from "../../../Core/Notifier";
import CustomCheckbox from "../../../Components/Checkbox.tsx";
import { Dayjs } from "dayjs";
import Switch, { SwitchProps } from "@mui/material/Switch";
import axios from "axios";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import VendorList from "../../Vendor/List"; 
import BillList from "../../Bill/List"; 
import InventoryList from "../../Inventory/List"; 


interface ModifierGroupSelection {
  id?: number;
  modifierGroupId: number;
  required: boolean;
  minimum: number;
  maximum: number;
  order: number | null;
  modifiers?:ModifierInfo[];
}


const Index = () => {
  const classes = useStyles();
  const theme = useTheme();
  const navigate = useNavigate();
  const LARAVEL_API_URL = process.env.REACT_APP_LARAVEL_API;
  const [searchQuery, setSearchQuery] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [selectedModifierGroupIds, setSelectedModifierGroupIds] = useState<number[]>([]);

    const [selectedProduct, setSelectedProduct] = useState<IVariantPopUP | null>(
      null
    );
     const getFormattedDate = (createDate: Dayjs | null): string => {
        return createDate ? createDate.format("YYYY-MM-DD") : "";
      };

     const [selectedProductBrandId, setSelectedProductBrandId] =
        useState<string>("");
      const [selectedProductCategoryId, setSelectedProductCategoryId] =
        useState<string>("");
      const [selectedProductTagIds, setSelectedProductTagIds] = useState<string[]>(
        []
      );
       const [selectedProductViewOnline, setSelectedProductViewOnline] =
          useState<string>("");
        const [startDate, setStartDate] = useState<Dayjs | null>(null);
          const [endDate, setEndDate] = useState<Dayjs | null>(null);
          const startDateAsDate = startDate?.toDate() || null;
          const endDateAsDate = endDate?.toDate() || null;
            const [createDate, setCreateDate] = useState<Dayjs | null>(null);
           const [currentSearchQuery, setCurrentSearchQuery] = useState("");
    const [openDialog, setOpenDialog] = useState(false);
    const [openCreateVariantDialog, setOpenCreateVariantDialog] = useState(false);
    const { showErrorMessage, showMessage } = useNotifier();
    const [openDeleteProduct, setOpenDeleteProduct] = useState(false);
    const [productToDelete, setProductToDelete] = useState<IVariantPopUP | null>(
      null
    );
  const [selectedCard, setSelectedCard] = useState<string | null>("Inventory");

  const API_URL = process.env.REACT_APP_API_URL;
const [showModifierGroupPopup, setShowModifierGroupPopup] = useState(false);
const [selectedModifierGroups, setSelectedModifierGroups] = useState<ModifierGroupSelection[]>([]);
const [selectedModifierGroupId, setSelectedModifierGroupId] = useState<number | null>(null);
const [modifierGroupDetails, setModifierGroupDetails] = useState<IModifierGroupPopUp | null>(null);

const [linkedProducts, setLinkedProducts] = useState<IProduct[]>([]);
const [selectedProducts, setSelectedProducts] = useState<IProduct[]>([]);
const [selectedLinkedProductId, setSelectedLinkProductId] = useState<number | null>(null);
const [showLinkedProductPopup, setShowLinkedProductPopup] = useState(false);
const [productSearchTerm, setProductSearchTerm] = useState("");
const [productSearchResults, setProductSearchResults] = useState([]);


  const { id: ProductId } = useParams<{ id: string }>();

  useEffect(() => {}, [ProductId]);

  

//   const { data, isLoading, isError, refetch: refetchProduct } = useGetProductQuery({
//     searchText: "",
//     id: String(ProductId),
//     productBrandId: null,
//     productCategoryId: null,
//     productTagIds: null,
//     productViewOnline: null,
//     createdDateStart: null,
//     createdDateEnd: null,
//     createdDate: null,
//   });
//   const { data: allProductsData } = useGetProductQuery({
//   searchText: "",
//   id: null,
//   productBrandId: null,
//   productCategoryId: null,
//   productTagIds: null,
//   productViewOnline: null,
//   createdDateStart: null,
//   createdDateEnd: null,
//   createdDate: null,
// });
  

//   const { data: productBrandData, isLoading: productBrandLoading } =
//     useGetProductBrandQuery({
//       searchText: "",
//       isActive: true,
//     });

//   const { data: tagData, isLoading: tagLoading } = useGetProductTagQuery({
//     searchText: "",
//     isActive: true,
//   });

//   const { data: printerData, isLoading: printerLoading } = useGetPrinterQuery({
//     searchText: "",
//   });

//   const { data: categoryData, isLoading: categoryLoading } =
//     useGetCategoryQuery();

//     const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(
//         null
//       );
//       const [selectedSubCategoryId, setSelectedSubCategoryId] = useState<
//         number | null
//       >(null);
    
//       const [selectedSubToSubCategoryId, setSelectedSubToSubCategoryId] = useState<
//         number | null
//       >(null);
    
//       const [selectedSubToSubToSubCategoryId, setSelectedSubToSubToSubCategoryId] =
//         useState<number | null>(null);
    
//       const { data: subCategoryData, refetch: refetchSubCategories } =
//         useGetSubCategoryByArrayQuery({
//           parent_ids: selectedCategoryId ? [Number(selectedCategoryId)] : [],
//         });
    
//       const { data: subCategory2Data, refetch: refetchS2bCategories } =
//         useGetSubCategoryByArrayQuery({
//           parent_ids: selectedSubCategoryId
//             ? [Number(selectedCategoryId), Number(selectedSubCategoryId)]
//             : [],
//         });
    
//       const { data: subCategory3Data, refetch: refetchS3bCategories } =
//         useGetSubCategoryByArrayQuery({
//           parent_ids: selectedSubCategoryId
//             ? [
//                 Number(selectedCategoryId),
//                 Number(selectedSubCategoryId),
//                 Number(selectedSubToSubCategoryId),
//               ]
//             : [],
//         });
    
   
//       const subCategoryList = useMemo(() => {
//         return subCategoryData?.data as ICategory[];
//       }, [subCategoryData?.data]);
    
//       const subToSubCategoryList = useMemo(() => {
//         return subCategory2Data?.data as ICategory[];
//       }, [subCategory2Data?.data]);
    
//       const subToSubToSubCategoryList = useMemo(() => {
//         return subCategory3Data?.data as ICategory[];
//       }, [subCategory3Data?.data]);
    
//       const productCategoryId = selectedSubToSubToSubCategoryId
//         ? Number(selectedSubToSubToSubCategoryId)
//         : selectedSubToSubCategoryId
//         ? Number(selectedSubToSubCategoryId)
//         : selectedSubCategoryId
//         ? Number(selectedSubCategoryId)
//         : selectedCategoryId
//         ? Number(selectedCategoryId)
//         : String("");

//   const product = useMemo(() => {
//     if (data && Array.isArray(data.data) && data.data.length > 0) {
//       return data.data[0] as IProduct;
//     }
//     return null;
//   }, [data]);
  

// React.useEffect(() => {
//   if (product?.modifierGroupId) {
//     if (typeof product.modifierGroupId === "string") {
//       try {
//         const parsed: ModifierGroupSelection[] = JSON.parse(product.modifierGroupId);
//         // Normalize required field to always be boolean
//         const normalized = parsed.map(item => ({
//           modifierGroupId: item.modifierGroupId,
//           required: item.required ?? false,
//           order: item.order ?? null, 
//           maximum: item.maximum ?? null,
//           minimum: item.minimum ?? null,
//              modifiers: Array.isArray(item.modifiers) ? item.modifiers : [], 
//         }));
//         setSelectedModifierGroups(normalized);
//       } catch (err) {
//         console.error("Failed to parse modifierGroupId", err);
//         setSelectedModifierGroups([]);
//       }
//     } else if (Array.isArray(product.modifierGroupId)) {
//       // Normalize required field to always be boolean
//       const normalized = product.modifierGroupId.map((item: any) => ({
//         modifierGroupId: item.modifierGroupId,
//         required: item.required ?? false,
//         order: item.order ?? null, 
//         maximum: item.maximum ?? null,
//         minimum: item.minimum ?? null,
// modifiers: Array.isArray(item.modifiers) ? item.modifiers : [], 
//       }));
//       setSelectedModifierGroups(normalized);
//     } else {
//       setSelectedModifierGroups([]);
//     }
//   } else {
//     setSelectedModifierGroups([]);
//   }
// }, [product]);

// React.useEffect(() => {
//   if (product?.linkedProductId) {
//     try {
//       const ids = JSON.parse(product.linkedProductId); // parse "[8,9]" → [8, 9]
//       setLinkedProducts(Array.isArray(ids) ? ids : []);
//     } catch {
//       setLinkedProducts([]);
//     }
//   } else {
//     setLinkedProducts([]);
//   }

// }, [product]);






//  const { data: variantData, isLoading: variantLoading } =
//     useGetVariantQuery({  searchText: "",
//     id: null,
//     productId: String(ProductId),
//     productBrandId: null,
//     productCategoryId: null,
//     productTagIds: null,
//     productViewOnline: null,
//     createdDateStart: null,
//     createdDateEnd: null,
//     createdDate: null,
//   });

  // const { data: modifierGroupData, isLoading: modifierLoading } = useGetModifierGroupQuery({
  //   productBrandId: selectedProductBrandId,
  //   productCategoryId: String(productCategoryId),
  //   productTagIds: selectedProductTagIds,
  //   modifierViewOnline: selectedProductViewOnline,
  //   createdDateStart: startDateAsDate as Date,
  //   createdDateEnd: endDateAsDate as Date,
  //   searchText: currentSearchQuery,
  //   createdDate: getFormattedDate(createDate),
  //   id: null,
  // });

    // const { data: modifierData } = useGetModifierQuery({
    //      productBrandId:  null,
    //     productCategoryId:  null,
    //     productTagIds: null,
    //     modifierViewOnline:null,
    //     createdDateEnd:  null,
    //     createdDateStart:null,
    //     searchText: null,
    //     createdDate: null,
    //     id:  "",
    //     });

          const { data : vendorData, isLoading: vendorIsLoading, isError: vendorIsError, refetch: vendorRefetch } = useGetVendorQuery({
            searchText: currentSearchQuery,
            id: "",
          });

          const { data : inventoryData, isLoading: inventoryIsLoading, isError: inventoryIsError, refetch: inventoryRefetch } = useGetInventoryQuery({
            searchText: currentSearchQuery,
            id: "",
          });

            const { data: billData, isLoading: billIsLoading, isError: billIsError, refetch: billRefetch } = useGetBillQuery({
              searchText: currentSearchQuery,
              id: "",
            });


//     const coursings: IVariantPopUP[] = Array.isArray(variantData?.data)
//       ? (variantData?.data as IVariantPopUP[])
//       : [];

    

//   const modifierGroupList: IModifierGroupPopUp[] = Array.isArray(modifierGroupData?.data)
//   ? (modifierGroupData?.data as IModifierGroupPopUp[])
//           : [];

//   const products: IProduct[] = Array.isArray(allProductsData?.data)
//   ? (allProductsData?.data as IProduct[])
//           : []; 

//   const modifierList = useMemo(() => {
//   return modifierData?.data as IModifierPopUp[];
//     }, [modifierData?.data]);

// const filteredModifierGroups = modifierGroupList.filter(
//   (group) =>
//     !selectedModifierGroups.some(
//       (selected) => Number(selected.modifierGroupId) === Number(group.id)
//     )
// );

// const filteredProducts = products.filter(
//   (group) => !linkedProducts.some(
//     (selectedId) => Number(selectedId) === Number(group.id) 
//   )
// );


//   const productBrandList = useMemo(() => {
//     return productBrandData?.data as IProductBrand[];
//   }, [productBrandData?.data]);

//   const productTagList = useMemo(() => {
//     return tagData?.data as IProductTag[];
//   }, [tagData?.data]);

//   const printerList = useMemo(() => {
//     return printerData?.data as IPrinter[];
//   }, [printerData?.data]);

//   const categoryList = useMemo(() => {
//     return categoryData?.data as ICategory[];
//   }, [categoryData?.data]);

//   const productBrandMap = useMemo(() => {
//     const map = new Map();
//     productBrandList?.forEach((brand) => {
//       map.set(brand.id, brand.productBrandName);
//     });
//     return map;
//   }, [productBrandList]);

//   const productTagMap = useMemo(() => {
//     const map = new Map();
//     productTagList?.forEach((tag) => {
//       map.set(tag.id, tag.tagName);
//     });
//     return map;
//   }, [productTagList]);

//   const ProductPrinterMap = useMemo(() => {
//     const map = new Map();
//     printerList?.forEach((printer) => {
//       map.set(printer.id, printer.printerName);
//     });
//     return map;
//   }, [printerList]);

//   const categoryMap = useMemo(() => {
//     const map = new Map();
//     categoryList?.forEach((category) => {
//       map.set(category.id, category.categoryName);
//     });
//     return map;
//   }, [categoryList]);

  const vendorList: IVendor[] = Array.isArray(vendorData?.data)
    ? (vendorData?.data as IVendor[])
    : [];

    
  const inventoryList: IProductInventory[] = Array.isArray(inventoryData?.data)
    ? (inventoryData?.data as IProductInventory[])
    : [];

  const billList: IQuoteWorkOrder[] = Array.isArray(billData?.data)
        ? (billData?.data as IQuoteWorkOrder[])
        : [];


  const cardsData = [
  {
    title: "Inventory",
    value: inventoryList?.length || 0,
  },
  {
    title: "Vendor",
    value:  vendorList?.length || 0
  },
  {
    title: "Bill",
    value:  billList?.length || 0  
  },
 

];




 const handleCreateOpenDialog = () => {
    setOpenCreateVariantDialog(true);
  };

  const handleCreateCloseDialog = () => {
    setOpenCreateVariantDialog(false);
  };

  const handleOpenDialog = (product: IVariantPopUP) => {
    setSelectedProduct(product);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setSelectedProduct(null);
    setOpenDialog(false);
  };

  const handleOpenDeletePopup = (product: IVariantPopUP) => {
    setProductToDelete(product);
    setOpenDeleteProduct(true);
  };

  const handleCloseDeletePopup = () => {
    setProductToDelete(null);
    setOpenDeleteProduct(false);
  };

//   const handleAddModifierGroup = (group: IModifierGroupPopUp) => {
//   const alreadyExists = selectedModifierGroups.some((g) => g.id === group.id);
//   if (!alreadyExists) {
//     setSelectedModifierGroups([...selectedModifierGroups, group]);
//   }
//   setShowModifierGroupPopup(false);
// };


  //  const [deleteVariant] = useDeleteVariantMutation();
  // const handleDelete = async (id: string) => {
  //   try {
  //     const response = await deleteVariant(id).unwrap();
  //     if (response.status) {
  //       showMessage("Deleted successfully");
  //       setOpenDeleteProduct(false);
  //     } else {
  //       showErrorMessage("Failed to delete the variant");
  //     }
  //   } catch (error) {
  //     showErrorMessage("Failed to delete the variant");
  //   }
  // };




// const handleSaveModifierGroups = async () => {
//   if (!modifierGroupDetails) return;



//   const groupId = Number(modifierGroupDetails.id);

//   // Check if this group already exists in the selectedModifierGroups array
//   const exists = selectedModifierGroups.some(g => g.modifierGroupId === groupId);

//   // Prepare the new/updated group data object
//   const newGroup = {
//     modifierGroupId: groupId,
//     required: modifierGroupDetails.required ?? false,
//     order: modifierGroupDetails.order ?? null,
//     minimum: modifierGroupDetails.minimum ?? 0,
//     maximum: modifierGroupDetails.maximum ?? 0,
//     modifiers: (modifierGroupDetails.modifiers || []).map((mod: any) => ({
//       modifier_id: mod.modifier_id,
//       overwrite: mod.overwrite ?? false,
//       overwrite_price: mod.overwrite_price ?? null,
//     })),
//   };

//   const isDuplicateOrder = selectedModifierGroups.some(g =>
//     g.modifierGroupId !== groupId && g.order === newGroup.order
//   );

//   if (isDuplicateOrder) {
//     showErrorMessage(`Order number ${newGroup.order} is already used. Please choose a different one.`);
//     return;
//   }

//   // Create updated array with new or replaced group
//   let updatedGroups = [];
//   if (exists) {
//     updatedGroups = selectedModifierGroups.map(g =>
//       g.modifierGroupId === groupId ? newGroup : g
//     );
//   } else {
//     updatedGroups = [...selectedModifierGroups, newGroup];
//   }

//   // Update local state immediately for responsiveness
//   setSelectedModifierGroups(updatedGroups);

//   // Prepare payload for API
//   const payload = {
//     productId: String(ProductId), // Make sure ProductId is in your component scope
//     modifierGroupId: JSON.stringify(updatedGroups),
//   };

//   try {
//     const response = await axios.put(`${API_URL}/update-modifierGroup`, payload, {
//       headers: {
//         'Content-Type': 'application/json',
//         Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
//       },
//     });

//     if (response.data.status) {
//       showMessage('Modifier groups saved successfully!');
//       refetchProduct();  // Optional: refetch your product data if needed
//       setShowModifierGroupPopup(false);
//       setSelectedModifierGroupId(null);
//       setModifierGroupDetails(null);
//     } else {
//       showErrorMessage(response.data.message || 'Failed to save modifier groups.');
//     }
//   } catch (error) {
//     console.error('Error saving modifier groups:', error);
//     showErrorMessage('Something went wrong. Please try again.');
//   }
// };

// const handleSaveLinkedProducts = async () => {
//   if (!linkedProducts || linkedProducts.length === 0) return;

//   // Get only IDs of newly selected products
//   const newLinkedIds = linkedProducts.map(p => p.id);

//   // Get previously saved linked product IDs from `product.linkedProductId`
//   let previousIds: number[] = [];
//   if (product?.linkedProductId) {
//     try {
//       const parsed = JSON.parse(product.linkedProductId); // e.g., [1,2]
//       previousIds = Array.isArray(parsed) ? parsed : [];
//     } catch {
//       previousIds = [];
//     }
//   }

//   // Merge previous and new IDs
//   const allIds = Array.from(new Set([...previousIds, ...newLinkedIds]));

//   try {
//     const response = await axios.put(`${API_URL}/update-linkedProducts`, {
//       productId: String(ProductId),
//       linkedProductIds: JSON.stringify(allIds), // send full array
//     }, {
//       headers: {
//         'Content-Type': 'application/json',
//         Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
//       },
//     });

//     if (response.data.status) {
//       showMessage('Linked products saved successfully!');
//       refetchProduct();
//       setShowLinkedProductPopup(false);
//     } else {
//       showErrorMessage(response.data.message || 'Failed to save linked products.');
//     }
//   } catch (error) {
//     console.error('Error saving linked products:', error);
//     showErrorMessage('Something went wrong. Please try again.');
//   }
// };





// const handleEditModifierGroup = (group: ModifierGroupSelection) => {
//   setSelectedModifierGroupId(group.modifierGroupId);
//   setModifierGroupDetails({
//      id: String(group.modifierGroupId), 
//     required: group.required,
//     order: group.order ?? undefined,
//     minimum: group.minimum,
//     maximum: group.maximum,
//     modifiers: group.modifiers ?? [],
//   });
//   setShowModifierGroupPopup(true);
// };

// const handleDeleteModifierGroup = async (modifierGroupId: number) => {
//   const confirmed = window.confirm("Are you sure you want to delete this modifier group?");
//   if (!confirmed) return; // Exit if user cancels

//   // Remove locally
//   const updatedGroups = selectedModifierGroups.filter(g => g.modifierGroupId !== modifierGroupId);


//   // Update backend (optional)
//   try {
//     await axios.put(`${API_URL}/update-modifierGroup`, {
//       productId: String(ProductId),
//       modifierGroupId: JSON.stringify(updatedGroups),
//     }, {
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem('token') || ''}`
//       }
//     });
//     showMessage('Modifier Group deleted successfully');
//     setSelectedModifierGroups(updatedGroups);
//   } catch (error) {
//     console.error(error);
//     showErrorMessage('Failed to delete Modifier Group');
//   }
// };

// const handleDeleteLinkedProduct = async (linkedProductId: any) => {
//   const confirmed = window.confirm("Are you sure you want to delete this linked product?");
//   if (!confirmed) return; // Exit if user cancels

//   // Remove locally
//   const updatedGroups = linkedProducts.filter((id) => id !== linkedProductId);

//   try {
//     await axios.put(`${API_URL}/update-linkedProducts`, {
//       productId: String(ProductId),
//       linkedProductIds: JSON.stringify(updatedGroups),
//     }, {
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem('token') || ''}`
//       }
//     });
//     showMessage('Linked product deleted successfully');
//     setLinkedProducts(updatedGroups);
//   } catch (error) {
//     console.error(error);
//     showErrorMessage('Failed to delete Linked product');
//   }
// };


  if (
    billIsLoading ||
    inventoryIsLoading ||
    vendorIsLoading 
  ) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (inventoryIsError) {
    return (
      <Typography color="error">
        Error fetching inventory details data. Please try again later.
      </Typography>
    );
  }

 



  return (
    <Grid container spacing={3}>
      {/* <Grid item lg={12} md={12} sm={12} xs={12}>
        <Card className={classes.stepperCard}>
          <Grid
            container
            justifyContent={"space-between"}
            spacing={5}
            sx={{ borderBottom: 2, padding: 2 }}
            className={classes.titleGrid}
          >
            <Grid
              item
              lg={9}
              md={9}
              sm={9}
              xs={9}
              pt={2}
              alignContent={"center"}
            >
              <Typography variant="h2">{product?.productName}</Typography>
            </Grid>
            <Grid
              item
              lg={3}
              md={3}
              sm={3}
              xs={3}
              pt={2}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Grid
                container
                spacing={1}
                justifyContent="flex-end"
                sx={{ display: "flex" }}
              >
                <Grid item>
                  <Button
                    variant="outlined"
                  startIcon={<ArrowBackIosNewIcon sx={{ fontSize: 40 }} />}
                    className={classes.addButton}
                    onClick={() => navigate(-1)}
                  >
                    Back
                  </Button>
                  
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Card>
      </Grid> */}
      
    <Grid item lg={12} md={12} sm={12} xs={12}>
        <Grid container spacing={2}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
           


<Grid container spacing={2} >
 <Grid container spacing={2} justifyContent="space-between" sx={{ marginTop: 1 }}>
  {[ // array of your 5 cards
    { title: 'Inventory', value: inventoryList?.length || 0, prefix: '', suffix: '' },
    { title: 'Vendor', value: vendorList?.length || 0, prefix: '', suffix: '' },
    { title: 'Bill', value: billList?.length || 0, prefix: '', suffix: '' }
  ].map((item, index) => (
    <Grid item xs={12} sm={6} md={4} key={index}  onClick={() => setSelectedCard(item.title)}  sx={{ cursor: "pointer" }}>
      <Card elevation={3}>
        <CardContent>
          <Grid container direction="column" alignItems="center">
            <Typography variant="h5" mt={2}>{item.title}</Typography>
            <Typography
              variant="h3"
              sx={{ marginTop: 2, fontWeight: "bold", color: "#4CAF50" }}
            >
              {item.prefix}{item.value}{item.suffix}
            </Typography>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  ))}
</Grid>



</Grid>
          
</Grid>
        

{selectedCard === "Vendor" && (
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <VendorList />
          </Grid>
      )}  

      {selectedCard === "Bill" && (
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <BillList />
          </Grid>
      )}  

         {selectedCard === "Inventory" && (
           <Grid item lg={12} md={12} sm={12} xs={12}>
            <InventoryList />
          </Grid>
      )}  


   



          {/* {product?.productDetailsIsLooping == true && (
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card className={classes.stepperCard} sx={{ minHeight: "250px" }}>
                <Grid container spacing={1}>
                  <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Typography variant="subtitle1">
                          <span className={classes.customerDetails}>
                            Looping :
                          </span>{" "}
                          {product?.loopingDetails?.shortTableName}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>

                  {product?.productDetailsIsLooping && (
                    <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                      <Card className={classes.stepperCard}>
                        <Grid
                          container
                          justifyContent={"space-between"}
                          spacing={2}
                          sx={{ padding: 2 }}
                          className={classes.titleGrid}
                        >
                          {product?.loopingDetails?.tableColumns.map(
                            (column, index) => (
                              <Grid
                                item
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                pt={2}
                                alignContent={"center"}
                                key={index}
                                className={
                                  classes.productViewPageTableHeaderCell
                                }
                              >
                                <Typography>
                                  <span className={classes.customerDetails}>
                                    {column.name} :
                                  </span>{" "}
                                  {column.type === "boolean"
                                    ? column.value
                                      ? "True"
                                      : "False"
                                    : column.value}
                                </Typography>
                              </Grid>
                            )
                          )}
                        </Grid>
                      </Card>
                    </Grid>
                  )}
                </Grid>
              </Card>
            </Grid>
          )} */}
        </Grid>
      </Grid>


    {/* <Dialog open={showModifierGroupPopup} onClose={() => setShowModifierGroupPopup(false)} maxWidth="md" fullWidth>
  <DialogTitle>Select Modifier Group</DialogTitle>
  <DialogContent >
  
  
  <FormControl fullWidth size="small" sx={{ mb: 2, mt: 2 }}>
<Autocomplete
  options={filteredModifierGroups}
  getOptionLabel={option => option.modifierGroupName ?? ''}
  value={
  modifierGroupList.find(group => Number(group.id) === selectedModifierGroupId) || null
}

  onChange={(event, newValue) => {
    if (newValue) {
      setSelectedModifierGroupId(Number(newValue.id));
      setModifierGroupDetails(newValue);
    } else {
      setSelectedModifierGroupId(null);
      setModifierGroupDetails(null);
    }
  }}

  renderInput={params => <TextField {...params} label="Select Modifier Group" size="small" />}
/>

</FormControl>

  
{modifierGroupDetails && (
  <>
<Grid container spacing={2} mt={1} mb={4}>
 <Grid item xs={6} md={3}>
  <TextField
    label="Minimum"
    type="number"
    size="small"
    fullWidth
    value={modifierGroupDetails.minimum ?? ''}
    onChange={(e) =>
      setModifierGroupDetails(prev =>
        prev
          ? {
              ...prev,
              minimum: e.target.value === '' ? 0 : parseInt(e.target.value, 10),
            }
          : prev
      )
    }
  />
</Grid>

<Grid item xs={6} md={3}>
  <TextField
    label="Maximum"
    type="number"
    size="small"
    fullWidth
    value={modifierGroupDetails.maximum ?? ''}
    onChange={(e) =>
      setModifierGroupDetails(prev =>
        prev
          ? {
              ...prev,
              maximum: e.target.value === '' ? 0 : parseInt(e.target.value, 10),
            }
          : prev
      )
    }
  />
</Grid>




      <Grid item xs={6} md={3}>
        <TextField
          label="Order No."
          type="number"
          size="small"
          fullWidth
          value={modifierGroupDetails.order ?? ''}
          onChange={(e) =>
            setModifierGroupDetails(prev => prev ? { ...prev, order: parseInt(e.target.value) || 0 } : prev)
          }
        />
      </Grid>

      <Grid item xs={6} md={3} display="flex" alignItems="center">
        <FormControlLabel
          control={
            <Switch
              checked={modifierGroupDetails.required ?? false}
              onChange={(e) =>
                setModifierGroupDetails(prev => prev ? { ...prev, required: e.target.checked } : prev)
              }
              color="primary"
            />
          }
          label="Required"
        />
      </Grid>
    </Grid>


    <Table className={classes.table} >
      <TableHead className={classes.tableHeaderRow}>
        <TableRow>
          <TableCell  className={classes.tablheader}> <strong>Modifier Name </strong></TableCell>
          <TableCell  className={classes.tablheader}> <strong>Overwrite</strong></TableCell>
          <TableCell  className={classes.tablheader}> <strong>Price</strong></TableCell>
        </TableRow>
      </TableHead>
     <TableBody>
    {(modifierGroupDetails.modifiers ?? []).map((mod, index) => {
      const modInfo = modifierList.find((m) => m.id === mod.modifier_id);
      const name = modInfo ? modInfo.modifierName : `ID: ${mod.modifier_id}`;

   const handleOverwriteChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  const updated = [...(modifierGroupDetails.modifiers ?? [])];
  updated[index] = { ...updated[index], overwrite: e.target.checked }; // Ensure immutability
  if (!e.target.checked) {
    updated[index].overwrite_price = 0;
  }
  setModifierGroupDetails({ ...modifierGroupDetails, modifiers: updated });
};

const handlePriceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  const updated = [...(modifierGroupDetails.modifiers ?? [])];
  updated[index] = {
    ...updated[index],
    overwrite_price: parseFloat(e.target.value) || 0,
  };
  setModifierGroupDetails({ ...modifierGroupDetails, modifiers: updated });
};

      return (
        <TableRow key={index}>
          <TableCell className={classes.tablCell}>{name}</TableCell>
          <TableCell className={classes.tablCell}>
            <CustomCheckbox
              checked={mod.overwrite || false}
              onChange={handleOverwriteChange}
              color="primary"
            />
          </TableCell>
          <TableCell className={classes.tablCell}>
           <TextField
  type="number"
  value={mod.overwrite ? mod.overwrite_price ?? '' : ''}
  onChange={handlePriceChange}
  inputProps={{ step: "0.01", min: "0" }}
  size="small"
  disabled={!mod.overwrite}
  sx={{
    minWidth: '80px',
    backgroundColor: mod.overwrite ? 'transparent' : 'transparent',
    visibility: mod.overwrite ? 'visible' : 'hidden', // still takes space
  }}
/>

          </TableCell>
        </TableRow>
      );
    })}
  </TableBody>
    </Table>

    
  </>
)}

  </DialogContent>
  <DialogActions>
   


<Grid item lg={12} md={12} sm={12} xs={12} >
                    <Card className={classes.card}>
                      <Grid container spacing={3} p={"24px"}>
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Button
     variant="outlined"
    className={classes.addButton}
    color="primary"
    onClick={() => setShowModifierGroupPopup(false)}
  >Cancel </Button>
                          <Box m={0.5}></Box>

                         <Button
    variant="contained"
    className={classes.addButton}
    color="primary"
    onClick={handleSaveModifierGroups}
  >
    Save
  </Button>

                        </Grid>
                      </Grid>
                    </Card>
                  </Grid>

</DialogActions>
</Dialog>



 <Dialog open={showLinkedProductPopup} onClose={() => setShowLinkedProductPopup(false)} maxWidth="md" fullWidth>
  <DialogTitle>Select Linked Products</DialogTitle>
  <DialogContent >
    <FormControl fullWidth size="small" sx={{ mb: 2, mt: 2 }}>
   <Autocomplete<IProduct>
      options={filteredProducts.filter(p => String(p.id) !== String(ProductId))}
    getOptionLabel={(option) => option.productName ?? ""}
   onChange={(event, newValue) => {
    console.log(ProductId, filteredProducts);
  if (newValue) {
    setLinkedProducts(prev => {
      const cleaned = prev.filter(p => p && typeof p === 'object');
      if (!cleaned.some(p => p.id === newValue.id)) {
        return [...cleaned, newValue];
      }
      return cleaned;
    });
  }
}}

    renderInput={(params) => <TextField {...params} label="Select Product" />}
  />
</FormControl>
  </DialogContent>
  <DialogActions>
   


<Grid item lg={12} md={12} sm={12} xs={12} >
                    <Card className={classes.card}>
                      <Grid container spacing={3} p={"24px"}>
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Button
     variant="outlined"
    className={classes.addButton}
    color="primary"
    onClick={() => setShowLinkedProductPopup(false)}
  >Cancel </Button>
                          <Box m={0.5}></Box>

                         <Button
    variant="contained"
    className={classes.addButton}
    color="primary"
    onClick={handleSaveLinkedProducts}
  >
    Save
  </Button>

                        </Grid>
                      </Grid>
                    </Card>
                  </Grid>

</DialogActions>
</Dialog> */}


    </Grid>








  );
};

export default Index;
